import React from "react";
import { FaHandPointRight } from "react-icons/fa";
import MenuBar from "../components/MenuBar";
import SearchMenu from "../components/SearchMenu";
import Footer from "../components/Footer";
import Disclaimer from "../components/Disclaimer";


function Privacy() {
  return (
    <>
      <SearchMenu />
      <MenuBar />

      <section className="  bg-slate-200 py-8">
        <div className="container-wrapper">
          <div>
            <h1 className=" text-2xl font-bold pb-2">PRIVACY POLICY</h1>
          </div>

          <div>
            <p className=" pb-2">
              At Unify Wellness Pvt Ltd, we value the trust you place in
              us.That's why we insist upon the highest standards for secure
              transactions and customer information privacy. Please read the
              following statement to learn about our information gathering and
              dissemination practices
            </p>

            <h2 className="text-2xl font-bold pb-2">Note:</h2>

            <p className=" flex gap-2 items-center mb-2">
              <FaHandPointRight /> Our privacy policy is subject to change at
              any time without notice. To make sure you are aware of any
              changes, please review this policy periodically.
            </p>
            <p className=" flex gap-2 items-center mb-2">
              <FaHandPointRight /> By visiting this Website you agree to be
              bound by the terms and conditions of this Privacy Policy. If you
              do not agree please do not use or access our Website.
            </p>
            <p className=" flex gap-2 items-center mb-2">
              <FaHandPointRight /> By mere use of the Website, you expressly
              consent to our use and disclosure of your personal information in
              accordance with this Privacy Policy.This Privacy Policy is
              incorporated into and subject to the Terms of Use.
            </p>

            <h2 className=" py-4 text-2xl font-bold">
              1. Collection of Personally Identifiable Information and other
              Information:
            </h2>

            <p className=" flex gap-2 items-center mb-2">
              When you use our Website, we collect and store your personal
              information which is provided by you from time to time. <br /> Our
              primary goal in doing so is to provide you a safe, efficient,
              smooth and customized experience.This allows us to provide <br />
              services and features that most likely meet your needs, and to
              customize our Website to make your experience safer and easier.{" "}
              <br />
              More importantly, while doing so we collect personal information
              from you that we consider necessary for achieving this purpose.
            </p>

            <p className=" flex gap-2 items-center mb-2">
              In general, you can browse the Website without telling us who you
              are or revealing any personal information about yourself. <br />{" "}
              Once you give us your personal information, you are not anonymous
              to us.Where possible, we indicate which fields are required and
              which <br />
              fields those are optional.You always have the option to not
              provide information by choosing not to use a particular service or{" "}
              <br />
              feature on the Website. We may automatically track certain
              information about you based upon your behaviour on our Website. We{" "}
              <br />
              use this information to do internal research on our user's
              demographics, interests, and behaviour to better understand,
              protect and serve our users. <br /> This information is compiled
              and analysed on an aggregated basis. This information may include
              the URL that you just came from (whether this URL <br /> is on our
              Website or not), which URL you next go to (whether this URL is on
              our Website or not), your computer browser information, and your
              IP address.
            </p>

            <h2 className=" py-4 text-2xl font-bold">
              2. Use of Demographic / Profile Data /Your Information:
            </h2>
            <p className=" flex gap-2 items-center mb-2">
              We use personal information to provide the services you request.To
              the extent we use your personal information to market to you,{" "}
              <br /> we will provide you the ability to opt-out of such uses. In
              our efforts to continually improve our product and service <br />
              offerings, we collect and analyse demographic and profile data
              about our users' activity on our Website
            </p>

            <p className=" flex gap-2 items-center mb-2">
              We identify and use your IP address to help diagnose problems with
              our server, and to administer our Website. <br />
              Your IP address is also used to help identify you and to gather
              broad demographic information.
            </p>

            <h2 className=" py-4 text-2xl font-bold">3. Cookies:</h2>
            <p className=" flex gap-2 items-center mb-2">
              A "cookie" is a small piece of information stored by a web server
              on a web browser so it can be later read back from that browser.
              Cookies are useful for enabling the browser to remember
              information specific to a given user. We place both permanent and
              temporary cookies in your computer's hard drive.The cookies do not
              contain any of your personally identifiable information.
            </p>

            <h2 className=" py-4 text-2xl font-bold">
              4. Sharing of personal information:
            </h2>

            <p className=" flex gap-2 items-center mb-2">
              We may disclose personal information if required to do so by law
              or in the good faith belief that such disclosure is reasonably
              necessary to respond to subpoenas, court orders, or other legal
              process.We may disclose personal information to law enforcement
              offices, third party rights owners, or others in the good faith
              belief that such disclosure is reasonably necessary to: enforce
              our Terms or Privacy Policy.
            </p>

            <p className=" flex gap-2 items-center mb-2">
              We and our affiliates will share / sell some or all of your
              personal information with another business entity should we (or
              our assets) plan to merge with, or be acquired by that business
              entity, or re-organization, amalgamation, restructuring of
              business. Should such a transaction occur that other business
              entity (or the new combined entity) will be required to follow
              this privacy policy with respect to your personal information.
            </p>

            <h2 className=" py-4 text-2xl font-bold">
              5. Links to Other Sites
            </h2>

            <p className=" flex gap-2 items-center mb-2">
              Our Website may link to other websites that may collect personally
              identifiable information about you.
            </p>

            <h2 className=" py-4 text-2xl font-bold">
              6. Security Precautions:
            </h2>
            <p className=" flex gap-2 items-center mb-2">
              Our Website has stringent security measures as applicable to
              protect the loss, misuse, and alteration of the information under
              our control. Once your information is in our possession we adhere
              to strict security guidelines, protecting it against unauthorized
              access.
            </p>

            <h2 className=" py-4 text-2xl font-bold">7. Your Consent:</h2>
            <p className=" flex gap-2 items-center mb-2">
              By using the Website and/ or by providing your information, you
              consent to the collection and use of the information you disclose
              on the Website in accordance with this Privacy Policy, including
              but not limited to your consent for sharing your information as
              per this privacy policy.
            </p>

            <p>
              If we decide to change our privacy policy, we will post those
              changes on this page so that you are always aware of what
              information we collect, how we use it, and under what
              circumstances we disclose it
            </p>
            <h2 className=" py-4 text-2xl font-bold">8. Contact details:</h2>

            <p className=" flex gap-2 items-center mb-2">
              If you have any questions about this privacy statement, the
              practices of this site or your dealings with this website, you can
              contact us.
            </p>
        <p>Company Name: unify wellness</p>
        <p>Email ID: director@unifywellness.com</p>
        <p>Mobile Number:+91 88519 24626 </p>
        {/* <p>
          Address: 55,2nd floor, Lane 2 , westend marg ,saidullajab, near saket
          metro station,new delhi ,110030
        </p> */}
          </div>
        </div>
      </section>

      <Footer />
      <Disclaimer />
    </>
  );
}

export default Privacy;
